export default "__VITE_ASSET__DwZVuH0S__"